export default function monthDiff(dateFrom, dateTo) {
  //   console.log(dateFrom, dateTo);
  return (
    dateTo.getMonth() -
    dateFrom.getMonth() +
    12 * (dateTo.getFullYear() - dateFrom.getFullYear())
  );
}
